import React, { Fragment, useState } from 'react';
import cls from '@utils/css-select'
import styles from './styles.scss'
import AcBtn from 'ac-components/ac-btn';
import EmptyTable from '../empty-table/main';
import { MainOrderItem } from 'pages/offical/personal/const';
import { moneyThousand } from '@utils/moneyFormat';
import { getPayUrl } from '@services/my-home';
import { sendEvent } from '@core/track';
import AcIcon from 'ac-components/ac-icon';
import { useTranslation } from 'hooks/use-translation';

const cx = cls(styles)

type RecordTableProps = {
	record?: MainOrderItem[];
	transData?: any;
}

export function PayButton(props: { orderNo: string | undefined; orderPaymentNo: string | undefined }) {
	const { orderNo, orderPaymentNo } = props
	const [btnLoading, setBtnLoading] = useState(false)
	const { transData } = useTranslation('profile')
	const handlePayClick = async () => {
		const _newTab = window.open('', '_blank')
		sendEvent({
			eventId: 'EAF_d5bc8191106db754'
		})
		try {
			setBtnLoading(true)
			const res = await getPayUrl({
				orderNo,
				orderPaymentNo
			})

			if (res.data) {
				// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
				// @ts-ignore
				_newTab.location.href = res.data
				// window.open(res.data)
			}
		} finally {
			setBtnLoading(false)
		}
	}

	return (<AcBtn size='medium' loading={btnLoading} onClick={handlePayClick}>{transData.pay}</AcBtn>)
}

function RecordTablePc(props: RecordTableProps) {
	const { record = [], transData } = props
	return (
		<>
			{record.length ? <ul className={cx('record-table_pc')}>
				<li className={cx('table-row', 'table-row_head')}>
					<div className={cx('table-cell')}>
						<div className={cx('pay-status-icon')} />
					</div>
					<div className={cx('table-cell')}>
						<div className={cx('order-date')}>
							<p>{transData.date}</p>
						</div>
					</div>
					<div className={cx('table-cell')}>
						<div>
							<p>{transData.orderContent}</p>
						</div>
					</div>
					<div className={cx('table-cell')}>
						<div className={cx('order-number')}>
							<p>{transData.orderNumber}</p>
						</div>
					</div>
					<div className={cx('table-cell')}>
						<div className={cx('order-price')}>
							<p>{transData.orderPrice}</p>
						</div>
					</div>
					<div className={cx('table-cell')}>
						<div className={cx('action')}>
							<span>{transData.action}</span>
						</div>
					</div>
				</li>
				{record.map(item => (
					<Fragment key={item.orderNo}>
						<li className={cx('table-row_body', 'table-row')} key={item.orderNo}>
							<div className={cx('table-cell')}>
								<div className={cx('pay-status-icon', { 'success': item.orderStatus === '2' })}>
									<AcIcon
										color={item.orderStatus === '2' ? '#52c51a' : '#ffd022'}
										icon={cx({
											'icon_progress_underway': item.orderStatus === '0' || item.orderStatus === '1', // 待支付
											'a-icon_progressdone': item.orderStatus === '2' // 已支付
										})} />
								</div>
							</div>
							<div className={cx('table-cell')}>
								<div>
									<span>{item.orderTime}</span>
								</div>
							</div>
							<div className={cx('table-cell')}>
								<div>
									<span>{item.orderContent}</span>
								</div>
							</div>
							<div className={cx('table-cell')}>
								<div>
									<span>{item.orderNo}</span>
								</div>
							</div>
							<div className={cx('table-cell')}>
								<div className={cx('order-price')}>
									<span>{`${item.paymentCurrency || 'RMB'}${moneyThousand(item.orderAmount)}`}</span>
								</div>
							</div>
							<div className={cx('table-cell')}>
								<div className={cx('action-btn_wrap')}>
									{
										!(item.subList?.length) && (item.orderStatus === '0' || item.orderStatus === '1') ?
											<PayButton orderNo={item.orderNo} orderPaymentNo='' /> : ''
									}
								</div>
							</div>
						</li>
						{item.subList?.length ? item.subList.map(subItem => (
							<li className={cx('table-row_body', 'table-row', 'table-row_sub')} key={subItem.subOutTradeNo}>
								<div className={cx('table-cell')} />
								<div className={cx('table-cell')}>
									<div>
										<span>{transData.subOrder}</span>
									</div>
								</div>
								<div className={cx('table-cell')} />
								<div className={cx('table-cell')}>
									<div>
										<span>{subItem.subOutTradeNo}</span>
									</div>
								</div>
								<div className={cx('table-cell')}>
									<div className={cx('order-price')}>
										<span>{`${item.paymentCurrency || 'RMB'}${moneyThousand(subItem.payAmount)}`}</span>
									</div>
								</div>
								<div className={cx('table-cell')}>
									<div className={cx('action-btn_wrap')}>
										{subItem.canPaid ? <PayButton orderNo={item.orderNo} orderPaymentNo={subItem.subOutTradeNo} /> : ''}
									</div>
								</div>
							</li>
						)) : ''}
					</Fragment>
				))}

			</ul> : EmptyTable()}
		</>
	)
}

export default RecordTablePc
